import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ScrollToTopButton from "../components/ScrollToTopButton";
import {
  TechVideo,
  BlueCard,
  TeamImg,
  IT1,
  IT2,
  Cup,
  Badge,
  Broadridge,
  CS,
  NYC1,
  NYC2,
  NYC3,
  NYC4,
  Proskauer,
  QSC,
  Thyssenkrupp,
  UniFresh,
  WVU,
  Petco,
  Icon1,
  Icon2,
  Icon3,
  WOBgCard,
  MWBE,
  ISO,
  Microsoft,
  BlueLarge,
  GroupPeople,
  WOBgLgCard,
  ProfileIcon,
  Video1_MoreThan20,
  Video2_MoreThan20,
  ClientsDiscuss,
  TechPLogo,
  Imgae377,
  Imgae378,
} from "../images/index";
import { Link } from "react-router-dom";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";
import useSlug from "./SlugComp";
import SEO from "./Seo";
import { getPagesBySlug } from "../services/apiService";

const images = [
  Thyssenkrupp,
  Broadridge,
  QSC,
  NYC2,
  NYC3,
  Petco,
  CS,
  NYC1,
  Proskauer,
  UniFresh,
  WVU,
  NYC4,
];

const recognizedImages = [MWBE, ISO, Microsoft];

const stats = [
  { value: 50, suffix: "+", label: "Enterprise Clients" },
  { value: 20, suffix: "+", label: "Years Of Client Success" },
  { value: 12, label: "Regional Distribution Center" },
  { value: 23, suffix: "%", label: "Inventory Turnover" },
];

const offerings = [
  {
    icon: <img src={Icon1} className="" />,
    title: "Global Capability Centers (GCC)",
    desc: "We design, build, and manage high-performance Global Capability Centers that drive innovation, accelerate time-to-market, and deliver measurable business outcomes. Our GCC model blends U.S.–India expertise for agile, product-centric execution.",
  },
  {
    icon: <img src={Icon2} className="" />,
    title: "Digital Transformation Solutions",
    desc: "From application development to AI-Driven automation, Cloud Migration, and CyberSecurity, we deliver end-to-end digital services that modernize operations, enhance customer experiences, and future-proof your enterprise.",
  },
  {
    icon: <img src={Icon3} className="" />,
    title: "Strategic Staffing & Workforce Solutions",
    desc: " We provide skilled IT professionals through flexible staffing models—contract, full-time, or project-based—ensuring you have the right talent at the right time to meet your business goals.",
  },
];

const testimonials = [
  {
    title: "Exceptional Support & Service",
    quote:
      "The TechProjects team has been amazing over the past two years—always responsive, solution-driven, and ready to help. They’ve exceeded my expectations, never said ‘no,’ and provided top-notch service with a positive attitude. I look forward to many more years of partnership!",
    name: "Ana Delgadillo Buhezo",
    role: "President of BeeSmart LLC",
    img: ProfileIcon,
  },
];
const heroSlides = [
  {
    id: 1,
    title: "GCC’s in Partnership with C&S Wholesale Grocers",
    desc: "C&S Wholesale Grocers, LLC is a leader in food solutions across the United States. Established in 1918.",
    image: TechPLogo,
  },
  {
    id: 2,
    title: "CyberSecurity & Cloud Practices ",
    desc: "Protecting enterprises with next-gen threat intelligence, zero-trust frameworks, and quantum-ready security solutions. Driving agility and scalability through secure, optimized, and cost-effective multi-cloud deployments.",
    image: "",
  },

  {
    id: 3,
    title: "Government Services",
    desc: "From city to state to federal levels, TechProjects helps public agencies modernize securely, deliver citizen-focused services, and ensure compliance with industry standards.",
    image: "",
  },
];
function Home() {
  // const isMobile = window.innerWidth <= 1024;
  const [isMobile, setIsMobile] = useState(true);
  const [metaData, setMetaData] = useState({});
  const slug = useSlug();
  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    const fetchJobs = async () => {
      try {
        const slugData = await getPagesBySlug("home");
        setMetaData(slugData.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    fetchJobs();
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/services");
  };
  const handleClickContact = () => {
    navigate("/contact");
  };
  const handleClickAbout = () => {
    navigate("/about");
  };

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [index, setIndex] = useState(0);

  const handlePrev = () => {
    setIndex((i) => (i - 1 + testimonials.length) % testimonials.length);
  };
  const handleNext = () => {
    setIndex((i) => (i + 1) % testimonials.length);
  };
  const t = testimonials[index];

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  const controls = useAnimation();
  const [scrollStarted, setScrollStarted] = useState(false);

  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: false,
  });
  const [ref2, inView2] = useInView({ threshold: 0.5, triggerOnce: false });
  const [ref3, inView3] = useInView({ threshold: 0.5, triggerOnce: false });
  const [ref4, inView4] = useInView({ threshold: 0.5, triggerOnce: false });
  const [ref5, inView5] = useInView({ threshold: 0.5, triggerOnce: false });
  const [ref6, inView6] = useInView({ threshold: 0.5, triggerOnce: false });
  const [ref7, inView7] = useInView({ threshold: 0.5, triggerOnce: false });
  const [ref8, inView8] = useInView({ threshold: 0.5, triggerOnce: false });

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 10) {
        setScrollStarted(true);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (scrollStarted && inView) {
      controls.start("visible");
    }
  }, [scrollStarted, inView, controls]);

  const navTo = (e) => {
    if (e === "Global Capability Centers (GCC)") {
      navigate("/Services/GCC");
    } else if (e === "Digital Transformation Solutions") {
      navigate("/Services/DST");
    } else if (e === "Strategic Staffing & Workforce Solutions") {
      navigate("/Services/SWS");
    }
  };
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <SEO {...metaData} />
      <div className="relative overflow-hidden">
        <div className="relative h-[calc(100vh-150px)] overflow-hidden">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="w-full h-full object-cover"
          >
            <source src={TechVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className="absolute bg-black font-roboto bg-opacity-[0.6] inset-0 flex items-center justify-start text-start text-white">
            {heroSlides.map((slide, index) => (
              <div
                key={slide.id}
                className={`absolute flex items-center flex-column sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto w-full mt-8 h-full px-6 sm:px-6 md:px-8 lg:px-8 xl:px-0 inset-0 transition-opacity duration-1000 ease-in-out ${
                  index === current ? "opacity-100 z-10" : "opacity-0 z-0"
                }`}
              >
                <div className="relative flex flex-col md:flex-row items-center md:items-start justify-center text-white px-6 md:px-0">
                  <div className="flex flex-col md:flex-row w-full max-w-7xl">
                    <div className="w-full md:w-[70%] flex flex-col justify-center pr-4">
                      {index === 0 ? (
  <motion.h1
    className="text-4xl md:text-6xl font-extrabold mb-8"
    initial={{ opacity: 0, y: -80 }}
    animate={inView ? { opacity: 0, y: -80 } : { opacity: 1, y: 0 }}
    transition={{
      duration: 0.8,
      ease: "easeOut",
      delay: 0.3,
    }}
  >
    {slide.title}
  </motion.h1>
) : (
  <motion.h2
    className="text-4xl md:text-6xl font-extrabold mb-8"
    initial={{ opacity: 0, y: -80 }}
    animate={inView ? { opacity: 0, y: -80 } : { opacity: 1, y: 0 }}
    transition={{
      duration: 0.8,
      ease: "easeOut",
      delay: 0.3,
    }}
  >
    {slide.title}
  </motion.h2>
)}
                      <motion.p
                        className="text-sm md:text-lg text-white"
                        initial={{ opacity: 0, y: 60 }}
                        animate={
                          inView ? { opacity: 0, y: 60 } : { opacity: 1, y: 0 }
                        }
                        transition={{
                          duration: 0.8,
                          ease: "easeOut",
                          delay: 0.3,
                        }}
                      >
                        {slide.desc}
                      </motion.p>
                    </div>
                    {slide?.image && (
                      <div className="w-[50%] md:w-[30%] px-10 flex items-center justify-center md:justify-end mt-8 md:mt-0">
                        <motion.img
                          initial={{ opacity: 0, y: 60 }}
                          animate={
                            inView
                              ? { opacity: 0, y: 60 }
                              : { opacity: 1, y: 0 }
                          }
                          transition={{
                            duration: 0.8,
                            ease: "easeOut",
                            delay: 0.3,
                          }}
                          src={slide?.image}
                          alt={slide?.title}
                          className="w-full object-contain"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}

            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-4 z-20">
              {heroSlides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrent(index)}
                  className={`w-4 h-4 rounded-full transition-all duration-300 ${
                    current === index ? "bg-activeColor w-12" : "bg-[#FDDFDF]"
                  }`}
                ></button>
              ))}
            </div>
          </div>
        </div>
        <div
          className="w-full h-[31vh] bg-cover bg-center bg-no-repeat md:p-0 p-5"
          style={{ backgroundImage: `url(${BlueCard})` }}
        >
          <div className="flex flex-col md:flex-row items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-4 md:px-0">
            <div className="font-roboto w-full md:max-w-3xl mb-6 md:mb-0 grid grid-cols-1 gap-4 text-center md:text-start">
              <p className="text-sm md:text-xl font-bold text-white tracking-widest">
                SMART IT SOLUTIONS
              </p>
              <h2 className="text-4xl md:text-7xl font-bold text-white">
                 For Business
              </h2>
            </div>

            <div className="w-full md:max-w-xl space-x-6 flex md:justify-end justify-center">
              {/* <button
              onClick={handleClick}
              type="submit"
              className="bg-white text-[#F32F39] text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 hover:text-white transition-all flex items-center gap-4"
            >
              Know More <i className="fa fa-arrow-right text-xs mt-1"></i>
            </button> */}
              <button
                onClick={handleClickContact}
                type="submit"
                className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-white hover:text-[#F32F39] transition-all flex items-center gap-4"
              >
                Contact Us <i className="fa fa-arrow-right text-xs mt-1"></i>
              </button>
            </div>
          </div>
        </div>
        <section className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] py-16 mx-auto flex font-roboto flex-col md:flex-row items-center gap-12 px-4 md:px-0">
          <div className="md:w-1/2 w-full" ref={ref}>
            <motion.div
              initial={!isMobile ? { opacity: 0, x: -100, scale: 0.95 } : {}}
              animate={
                !isMobile
                  ? inView
                    ? { opacity: 1, x: 0, scale: 1, rotate: 0 }
                    : { opacity: 0, x: -100, scale: 0.95, rotate: 0 }
                  : {}
              }
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="rounded-2xl overflow-hidden shadow-lg border border-gray-100"
            >
              <img
                src={TeamImg}
                alt="Team working"
                className="w-full h-auto object-cover"
              />
            </motion.div>
          </div>

          <div className="md:w-1/2 w-full space-y-8" ref={ref}>
            <motion.div
              ref={ref}
              initial={!isMobile ? { opacity: 0, x: 100, scale: 0.95 } : {}}
              animate={
                !isMobile
                  ? inView
                    ? { opacity: 1, x: 0, scale: 1, rotate: 0 }
                    : { opacity: 0, x: 100, scale: 0.95, rotate: 0 }
                  : {}
              }
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-4">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <h3 className="text-[#475569] font-bold text-xl uppercase">
                  About TechProjects
                </h3>
              </span>

              <h2 className="text-4xl md:text-[4rem] font-extrabold text-[#434253] mb-6">
                Who We Are
              </h2>

              <p className="text-[#404040] text-lg text-justify leading-relaxed mb-8">
                At TechProjects, we go beyond traditional IT services — we’re a
                strategic technology partner focused on innovation, impact, and
                scalability. With over 20 years of experience, we deliver
                AI-driven solutions, global capability centers, and enterprise
                transformation across industries.
              </p>

              <button
                onClick={handleClickAbout}
                type="submit"
                className="bg-activeColor text-white text-2xl px-6 py-3 rounded-md font-500 hover:bg-red-600 transition-all flex items-center gap-6"
              >
                View More <i className="fa fa-arrow-right text-xs mt-1"></i>
              </button>
            </motion.div>
          </div>
        </section>

        <section className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto bg-white text-center font-roboto px-4 md:px-0">
          <div className=" space-y-4 mb-6">
            <div className="flex justify-center">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
            </div>
            <h2 className="text-3xl md:text-7xl font-extrabold font-extrabold text-[#434253] leading-tight">
              More Than 20+ Years of Innovation <br /> in IT & Talent Solutions
            </h2>
            <p className="text-[#404040] text-lg text-base md:text-lg leading-relaxed">
              At TechProjects, we’ve spent over two decades delivering
              intelligent, agile, and scalable technology solutions to global
              enterprises. From AI-powered automation to GCC operations, our
              commitment is to innovation with impact.
            </p>
          </div>

          <div
            className="grid md:grid-cols-2 gap-0 mx-auto overflow-hidden"
            ref={ref2}
          >
            <div className="flex flex-col">
              <motion.video
                initial={!isMobile ? { opacity: 0, x: 80 } : {}}
                animate={
                  !isMobile
                    ? inView2
                      ? { opacity: 1, x: 0 }
                      : { opacity: 0, x: -80 }
                    : {}
                }
                transition={{ duration: 0.8 }}
                autoPlay
                loop
                muted
                playsInline
                webkit-playsinline="true"
                x5-playsinline="true"
                preload="auto"
                type="video/mp4"
                src={Video1_MoreThan20}
                className="w-full md:h-[285px] object-cover"
              ></motion.video>

              <motion.div
                ref={ref7}
                initial={!isMobile ? { opacity: 0, x: 80 } : {}}
                animate={
                  !isMobile
                    ? inView7
                      ? { opacity: 1, x: 0 }
                      : { opacity: 0, x: -80 }
                    : {}
                }
                transition={{ duration: 0.8 }}
                className="relative bg-white py-8 px-6 flex flex-col items-center rounded-tl-3xl rounded-tr-3xl md:rounded-tr-md
             -mt-10 z-10 md:ml-20 ml-10 mr-10 md:mr-1"
              >
                <div className="flex items-center justify-center mb-4">
                  <img
                    src={Badge}
                    alt="Badge"
                    className="w-full object-cover"
                  />
                </div>
                <p className="text-[#38384F] font-semibold text-lg md:text-xl text-center">
                  Delivered 120+ Projects Across U.S. <br /> and India
                </p>
              </motion.div>
            </div>

            <div className="flex flex-col">
              <motion.video
                initial={!isMobile ? { opacity: 0, x: -80 } : {}}
                animate={
                  !isMobile
                    ? inView2
                      ? { opacity: 1, x: 0 }
                      : { opacity: 0, x: 80 }
                    : {}
                }
                transition={{ duration: 0.8 }}
                autoPlay
                loop
                muted
                playsInline
                webkit-playsinline="true"
                x5-playsinline="true"
                preload="auto"
                type="video/mp4"
                src={Video2_MoreThan20}
                className="w-full md:h-[285px] object-cover"
              ></motion.video>

              <motion.div
                ref={ref7}
                initial={!isMobile ? { opacity: 0, x: -80 } : {}}
                animate={
                  !isMobile
                    ? inView7
                      ? { opacity: 1, x: 0 }
                      : { opacity: 0, x: 80 }
                    : {}
                }
                transition={{ duration: 0.8 }}
                className="relative bg-white py-8 px-6 flex flex-col items-center rounded-tr-3xl rounded-tl-3xl md:rounded-tl-md
             -mt-10 mr-10 md:mr-20 ml-10 md:ml-1 z-10"
              >
                <div className="flex items-center justify-center mb-4">
                  <img src={Cup} alt="Cup" className="w-full object-cover" />
                </div>
                <p className="text-[#38384F] font-semibold text-lg md:text-xl text-center">
                  Awarded “Best Digital Partner” for <br /> Retail Clients
                </p>
              </motion.div>
            </div>
          </div>
        </section>
        <section className="bg-[#F3F3F3] text-center font-roboto py-16 px-4 md:px-0">
          <div className="relative w-full overflow-hidden">
            <div className="flex animate-scroll-horizontal gap-6">
              {images.concat(images).map((img, i) => (
                <img key={i} src={img} alt={`scroll-${i}`} className="" />
              ))}
            </div>
          </div>
        </section>
        <section className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto bg-white text-center font-roboto px-4 py-10 md:px-0">
          <div className="space-y-8 mb-16">
            <div className="flex justify-center items-center gap-2 mb-2">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <h3 className="text-[#475569] font-bold text-xl uppercase">
                  Innovate. Secure. Scale.
                </h3>
              </span>
            </div>
            <h2 className="text-4xl md:text-7xl font-extrabold text-[#434253] mb-6">
              What We Offer
            </h2>

            <p className="text-[#404040] text-lg text-center leading-relaxed mb-8">
              At TechProjects, we help businesses grow, stay secure, and
              succeed. We build capability centers, improve digital systems, and
              provide the right talent—quickly and reliably.
            </p>
          </div>

          <div
            className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto"
            ref={ref4}
          >
            {offerings.map((item, idx) => (
              <motion.div
                initial={!isMobile ? { opacity: 0, y: 80 } : {}}
                animate={
                  !isMobile
                    ? inView4
                      ? { opacity: 1, y: 0 }
                      : { opacity: 0, y: 80 }
                    : {}
                }
                transition={{ duration: 0.2 }}
                key={idx}
                className="group flex flex-col items-start text-left p-2 transition-all duration-300"
              >
                <div className="mb-4 p-4 rounded-xl">{item.icon}</div>
                <h3 className="text-2xl font-bold text-[#0F172A] mb-2">
                  {item.title}
                </h3>
                <p className="text-[#0F172A] text-lg font-400 flex-grow text-justify">
                  {item.desc}
                </p>
                <button
                  onClick={() => navTo(offerings[idx].title)}
                  className="mt-4 border border-[#EAF0FF] rounded-[8px] text-[#F42F39] hover:bg-[#e94e3c] hover:text-white transition-all duration-300"
                >
                  <i className="fa fa-arrow-right px-2 text-xs font-800 "></i>
                </button>
              </motion.div>
            ))}
          </div>
        </section>
        <div className="font-roboto relative">
          <section
            className="text-white min-h-[60vh] py-8 md:py-14 relative overflow-hidden bg-[length:100%_100%] bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${BlueLarge})` }}
          >
            <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] space-y-8 mx-auto text-center px-3 md:px-6">
              <span className="flex items-center justify-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-5 h-1.5 bg-activeColor"></span>
                <span className="w-9 h-1.5 bg-activeColor"></span>
              </span>
              <h2 className="text-2xl md:text-4xl xl:text-6xl font-extrabold text-white leading-tight">
                More Than 50+ Clients Trust TechProjects for Innovation
              </h2>

              <div
                ref={ref5}
                className="flex flex-wrap justify-between gap-3 md:gap-12 mt-10"
              >
                {stats.map((item, index) => (
                  <div key={index} className="text-center flex-1 min-w-[120px]">
                    <p className="text-3xl md:text-4xl font-bold">
                      {inView5 ? (
                        <CountUp
                          end={item.value}
                          duration={2}
                          suffix={item.suffix || ""}
                        />
                      ) : (
                        0
                      )}
                    </p>
                    <p className="text-md tracking-wider font-normal opacity-90">
                      {item.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>
          <div className="absolute left-1/2 -translate-x-1/2 md:top-[31%] top-[35%] w-[90vw] md:w-[700px] p-2 rounded-md z-20">
            <img
              src={ClientsDiscuss}
              alt="Clients"
              className="w-full h-auto rounded-md"
            />
          </div>
          {/* <div className="absolute left-1/2 -translate-x-1/2 md:top-[30%] top-[35%] w-[90vw] md:w-[700px]  p-2 rounded-md z-20">
          <img src={ClientsDiscuss} alt="" />
          <video
            playsInline
            webkit-playsinline="true"
            x5-playsinline="true"
            preload="auto"
            loop
            ref={videoRef}
            type="video/mp4"
            src={VideoMoreThan50}
            className="w-full h-[180px] md:h-[380px] object-cover rounded-md"
            muted
          ></video>
          <button
            onClick={handlePlayPause}
            className="absolute inset-0 flex items-center justify-center transition-all"
          >
            <div className="border border-white border-[5px] rounded-full px-[18px] py-[12px] shadow-lg">
              {isPlaying ? (
                <i className="fa fa-pause text-4xl text-white"></i>
              ) : (
                <i className="fa fa-play text-4xl text-white pl-1"></i>
              )}
            </div>
          </button>
        </div> */}

          <section className="bg-white pt-24 md:pt-56 pb-12 md:pb-20 relative overflow-hidden px-6 md:px-0">
            {/* <div className="absolute hidden md:block right-3 md:right-[34rem] top-1/4 -translate-y-1/2 w-16 h-16 md:w-[170px] md:h-[170px] border-4 md:border-[30px] border-[#f42f39] rounded-full z-9"></div> */}
            <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-12 mt-8 md:mt-8">
              <div className="flex-1 space-y-4">
                <span className="flex items-start justify-start font-bold text-lg tracking-wider space-x-2">
                  <span className="w-5 h-1.5 bg-activeColor"></span>
                  <span className="w-9 h-1.5 bg-activeColor"></span>
                </span>
                <h3 className="text-[#434253] font-medium text-2xl md:text-3xl mb-4">
                  Strengthen Your CyberSecurity with TechProjects’ 24/7 SOC
                </h3>
              </div>
              <div className="flex-1 flex justify-center md:justify-start">
                <p className="text-[#434253] font-normal text-justify md:text-lg">
                  Stay ahead of threats with real-time monitoring, advanced
                  threat detection, and rapid incident response from our
                  dedicated Security Operations Center (SOC). We protect your
                  business from ransomware, phishing, and data breaches — so you
                  can focus on growth with confidence.
                </p>
              </div>
            </div>
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12 mt-8 md:mt-10">
              <div>
                <button
                  onClick={() => navigate("/Services/CSC")}
                  type="submit"
                  className="bg-activeColor text-white px-6 py-3 rounded-md text-2xl w-full md:w-auto hover:bg-red-600 transition-all flex items-center gap-3"
                >
                  Test Your Security With Us
                  <i className="fa fa-arrow-right text-xs mt-1"></i>
                </button>
              </div>
            </div>
          </section>
        </div>

        <div
          className="w-full p-[8vh] bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${WOBgCard})` }}
        >
          <div className="grid space-y-6 text-center items-center justify-center font-roboto h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto px-6 md:px-0">
            <h2 className="font-bold text-3xl md:text-4xl text-[#434253]">
              Recognized & Trusted:
            </h2>

            <div className="flex flex-wrap justify-center items-center gap-6">
              {recognizedImages.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`scroll-${i}`}
                  className="w-auto object-contain"
                />
              ))}
            </div>
          </div>
        </div>
        <div className="bg-white sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto py-10 font-roboto px-6 md:px-0">
          <div className="text-center space-y-6 mb-10">
            <span className="flex items-start justify-center font-bold text-lg tracking-wider space-x-2">
              <span className="w-5 h-1.5 bg-activeColor"></span>
              <span className="w-9 h-1.5 bg-activeColor"></span>
            </span>
            <h2 className="text-3xl md:text-7xl font-bold text-[#434253]">
              Case Study / Project Impact
            </h2>
          </div>

          <motion.div
            initial={!isMobile ? { opacity: 0, x: -80 } : {}}
            animate={
              !isMobile
                ? inView3
                  ? { opacity: 1, x: 0 }
                  : { opacity: 0, x: 80 }
                : {}
            }
            transition={{ duration: 0.8 }}
            className="md:flex md:items-center md:gap-16 mb-16"
            ref={ref3}
          >
            <div className="md:w-1/3 flex justify-center mb-6 md:mb-0">
              <img
                src={Imgae377}
                alt="DOE NYC Case Study"
                className="rounded-lg shadow-md w-full max-w-md object-cover"
              />
            </div>
            <div className="md:w-2/3 space-y-6">
              <h2 className="text-2xl md:text-4xl font-500 text-[#434253] mb-2">
                Educational Client – CyberSecurity Modernization
              </h2>
              <p className="text-[#434253] font-400 text-lg mb-4">
                We led a two-year, multi-million-dollar project to secure one of
                the largest public education systems in the U.S.
              </p>
              <ul className="list-disc space-y-2 ml-5 text-[#434253] font-400 text-lg">
                <li>
                  A dedicated 24-member team delivered the project successfully
                  — on time and within the planned two-year schedule
                </li>
                <li>Aligned security with NIST and CIS standards</li>
                <li>Reduced incident response time by 40%</li>
                <li>
                  Established a third-party risk management program still
                  running today
                  <br />
                  Result: A secure, compliant, and future-ready IT environment
                  for over 1 million students and staff.
                </li>
              </ul>
            </div>
          </motion.div>

          <motion.div
            initial={!isMobile ? { opacity: 0, x: 80 } : {}}
            animate={
              !isMobile
                ? inView3
                  ? { opacity: 1, x: 0 }
                  : { opacity: 0, x: -80 }
                : {}
            }
            transition={{ duration: 0.8 }}
            className="md:flex md:flex-row-reverse md:items-center md:gap-16"
            ref={ref8}
          >
            <div className="md:w-1/3 flex justify-center mb-6 md:mb-0">
              <img
                src={Imgae378}
                alt="Grocery Case Study"
                className="rounded-lg shadow-md w-full max-w-md object-cover"
              />
            </div>
            <div className="md:w-2/3 space-y-6">
              <h2 className="text-2xl md:text-4xl font-500 text-[#434253] mb-2">
                Wholesale Grocery Leader – AI Demand Forecasting & Inventory
                Optimization
              </h2>
              <p className="text-[#434253] font-400 text-lg mb-4">
                We deployed AI/ML models to forecast demand at the
                SKU-location-day level, optimizing stock levels and reducing
                waste.
              </p>
              <ul className="list-disc space-y-2 ml-5 text-[#434253] font-400 text-lg">
                <li>Reduced perishable spoilage losses by 17%</li>
                <li>Improved inventory turnover by 23%</li>
                <li>
                  Integrated seamlessly with ERP and warehouse systems
                  <br />
                  Result: Higher efficiency, lower costs, and better on-shelf
                  availability for thousands of grocery items across 12 regional
                  distribution centers.
                </li>
              </ul>
            </div>
          </motion.div>
        </div>

        <div
          className="w-full h-[31vh] bg-cover bg-center bg-no-repeat md:p-0 p-5"
          style={{ backgroundImage: `url(${BlueCard})` }}
        >
          <div className="flex flex-col md:flex-row items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0">
            <div className="font-roboto w-full md:max-w-3xl mb-6 md:mb-0 grid grid-cols-1 gap-4">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-5 h-1.5 bg-activeColor"></span>
                <span className="w-9 h-1.5 bg-activeColor"></span>
              </span>
              <span className="text-2xl md:text-4xl text-white font-medium">
                Looking for Scalable IT & Talent Solutions That Deliver Results?
              </span>
            </div>

            <div className="w-full md:max-w-xl flex md:justify-end justify-center">
              <button
                onClick={handleClickContact}
                type="submit"
                className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                Contact Us <i className="fa fa-arrow-right text-xs mt-1"></i>
              </button>
            </div>
          </div>
        </div>
        {/* <motion.div
        ref={ref6}
        className="bg-[#f7f7f8] bg-cover bg-center bg-no-repeat py-[5rem] px-2 font-roboto"
        style={{ backgroundImage: `url(${WOBgLgCard})` }}
        initial={!isMobile ? { opacity: 0, x: 80 } : {}}
        animate={
          !isMobile
            ? inView6
              ? { opacity: 1, x: 0 }
              : { opacity: 0, x: -80 }
            : {}
        }
        transition={{ duration: 0.8 }}
      >
        <section className="max-w-6xl mx-auto">
          <h2 className="text-center text-2xl md:text-4xl lg:text-6xl font-extrabold text-[#434253] mb-8">
            What Our Client’s Say About us
          </h2>
          <div className="relative w-full flex justify-center">
            <button
              className={`hidden sm:block absolute left-4 md:left-20 top-1/2 -translate-y-1/2 bg-white rounded-full shadow p-2
           ${index === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
              onClick={handlePrev}
              disabled={index === 0}
            >
              <i
                className="fa fa-chevron-left px-[8px] py-[5px]"
                aria-hidden="true"
              ></i>
            </button>

            <div className="bg-white rounded-2xl shadow-lg w-full max-w-md md:max-w-2xl lg:max-w-3xl py-8 md:py-10 px-4 md:px-10 flex flex-col items-center text-center">
              <h3 className="font-bold text-xl md:text-[32px] mb-4 text-[#0F172A]">
                {t.title}
              </h3>
              <p className="mb-6 text-base md:text-2xl text-[#0F172A] text-center font-normal">
                &quot;{t.quote}&quot;
              </p>
              <img
                src={t.img}
                alt={t.name}
                className="mx-auto rounded-full w-20 h-20 md:w-28 md:h-28 object-cover mb-2 border-4 border-white shadow"
              />
              <div>
                <p className="font-normal text-[#0F172A] text-lg">{t.name}</p>
                <p className="text-[#475569] font-normal text-md">{t.role}</p>
              </div>
            </div>

            <button
              className={`hidden sm:block absolute right-4 md:right-20 top-1/2 -translate-y-1/2 bg-white rounded-full shadow p-2 
           ${
             index === testimonials.length - 1
               ? "opacity-50 cursor-not-allowed"
               : ""
           }`}
              onClick={handleNext}
              disabled={index === testimonials.length - 1}
            >
              <i
                className="fa fa-chevron-right px-[8px] py-[5px]"
                aria-hidden="true"
              ></i>
            </button>
          </div>
          
          <div className="flex sm:hidden justify-between max-w-md mx-auto mt-3">
            <button
              className={`bg-white rounded-full shadow p-2 ${
                index === 0 ? "opacity-50 cursor-not-allowed" : ""
              }`}
              onClick={handlePrev}
              disabled={index === 0}
            >
              <i className="fa fa-chevron-left" aria-hidden="true"></i>
            </button>
            <button
              className={`bg-white rounded-full shadow p-2 ${
                index === testimonials.length - 1
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
              onClick={handleNext}
              disabled={index === testimonials.length - 1}
            >
              <i className="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </section>
      </motion.div> */}

        <ScrollToTopButton />
      </div>
    </>
  );
}

export default Home;
